import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { Button, TextareaAutosize } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { addCaseNote } from '../../reducers/caseNotes';

const useStyles = makeStyles(theme => ({
  newMessage: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column'
  },
  sendWrapper: {
    alignSelf: 'flex-end'
  },
  textarea: {
    width: '100%',
    padding: theme.spacing(1),
    borderColor: theme.palette.divider,
    minHeight: 80,
    maxHeight: 150
  },
  textAreaWrapper: {
    display: 'flex',
    marginBottom: theme.spacing(1)
  }
}));

const AddNote = ({ send, sending }) => {
  const [message, setMessage] = React.useState('');

  const classes = useStyles();
  const handleChange = event => {
    setMessage(event.target.value);
  };

  const handleSend = () => {
    send(message).then(() => {
      setMessage('');
    });
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSend();
    }
  };

  return (
    <Paper className={classes.newMessage} elevation={1}>
      <div className={classes.textAreaWrapper}>
        <TextareaAutosize
          disabled={sending}
          value={message}
          onChange={handleChange}
          className={classes.textarea}
          minRows={3}
        />
      </div>
      <div className={classes.sendWrapper}>
        <Button
          variant="contained"
          color="primary"
          size="medium"
          startIcon={<SendIcon />}
          disabled={!message || sending}
          onKeyDown={handleKeyPress}
          onClick={handleSend}
        >
          {sending ? 'Sending...' : 'Send'}
        </Button>
      </div>
    </Paper>
  );
};

AddNote.propTypes = {
  send: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired
};

export default connect(
  (state, { patientId }) => {
    const localState = state.caseNotes;

    return {
      sending: localState.patientId === patientId ? state.caseNotes.sending : false
    };
  },
  (dispatch, { patientId }) => {
    return {
      send: message => dispatch(addCaseNote(patientId, message))
    };
  }
)(AddNote);
